import { Modal, Spinner, Button } from 'react-bootstrap';
import './ConnectionModal.css';

/**
 * ConnectionModal — shown when the SignalR connection is lost or reconnecting.
 *
 * Props:
 *   status  {"connected" | "reconnecting" | "disconnected"}  — current connection lifecycle state
 */
const ConnectionModal = ({ status }) => {
    const show = status === 'reconnecting' || status === 'disconnected';

    return (
        <Modal show={show} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>
                    {status === 'reconnecting' ? 'Connection Lost' : 'Connection Failed'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="connection-modal-body">
                {status === 'reconnecting' && (
                    <>
                        <Spinner animation="border" role="status" className="connection-modal-spinner" />
                        <p>Connection lost &mdash; reconnecting...</p>
                    </>
                )}
                {status === 'disconnected' && (
                    <p>Could not reconnect. Please refresh the page.</p>
                )}
            </Modal.Body>
            {status === 'disconnected' && (
                <Modal.Footer>
                    <Button variant="primary" onClick={() => window.location.reload()}>
                        Reload
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default ConnectionModal;
